var map = {
	"./pages/about.vue": [
		"ff3c",
		"chunk-1093dcdd"
	],
	"./pages/contact.vue": [
		"c444",
		"chunk-12ed242c"
	],
	"./pages/inquiry.vue": [
		"d94a",
		"chunk-7feca148"
	],
	"./pages/language-root.vue": [
		"3441",
		"chunk-2d0b9994"
	],
	"./pages/parallax-test.vue": [
		"c1d8",
		"chunk-0bfc17da",
		"chunk-59e9af84"
	],
	"./pages/works-article.vue": [
		"f027",
		"chunk-0bfc17da",
		"chunk-76de1c50"
	],
	"./pages/works-list.vue": [
		"c94f",
		"chunk-5974b307"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "87e4";
module.exports = webpackAsyncContext;